
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountTypeBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rowIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importedRow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transformedRow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transformedRowDetail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schemaErrors"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":139}};
    doc.loc.source = {"body":"fragment AccountTypeBase on AccountType {\n  id\n  rowIndex\n  batchId\n  importedRow\n  transformedRow\n  transformedRowDetail\n  schemaErrors\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
